// extracted by mini-css-extract-plugin
export default {"forgotPassword":"styles_forgotPassword__1sDPg"};